import { render, staticRenderFns } from "./statisticalReportDetail.vue?vue&type=template&id=5348cdf6&scoped=true"
import script from "./statisticalReportDetail.vue?vue&type=script&lang=js"
export * from "./statisticalReportDetail.vue?vue&type=script&lang=js"
import style0 from "./statisticalReportDetail.vue?vue&type=style&index=0&id=5348cdf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5348cdf6",
  null
  
)

export default component.exports